const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrizeBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_5374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.96194 7.32337L9.82766 6.26073L10.6745 5.60448L10.1423 4.67509L10.6744 3.74567L9.82764 3.08942L9.96192 2.02676L8.92876 1.7456L8.64761 0.712478L7.58497 0.846752L6.92874 2.34375e-05L5.99935 0.532149L5.06994 0L4.41369 0.846845L3.35103 0.712525L3.06987 1.74568L2.03674 2.02683L2.17102 3.08947L1.32422 3.74574L1.85634 4.67513L1.32422 5.60455L2.17102 6.2608L2.03674 7.32346L3.01742 7.59034L1.64656 10.8999L3.21214 10.8763L4.30243 12L5.50264 9.10249L5.99935 8.81807L6.49606 9.10246L7.69628 12L8.78657 10.8763L10.3521 10.8999L8.98127 7.5903L9.96194 7.32337ZM4.06222 10.7428L3.50522 10.1688L2.70542 10.1808L3.34852 8.62827L3.3511 8.63774L4.41373 8.50342L4.78918 8.98788L4.06222 10.7428ZM5.99933 8.00798L5.25116 8.43635L4.72358 7.7556L3.86897 7.8636L3.64261 7.03183L2.81082 6.80547L2.91884 5.95084L2.23817 5.42331L2.66656 4.67511L2.23817 3.92694L2.91889 3.39938L2.81089 2.54478L3.64266 2.31842L3.86902 1.48664L4.72365 1.59464L5.25118 0.9139L5.99935 1.34229L6.74753 0.9139L7.27511 1.59462L8.12971 1.48662L8.35607 2.3184L9.18787 2.54475L9.07984 3.39938L9.76056 3.92691L9.33217 4.67511L9.76052 5.42331L9.0798 5.95084L9.18782 6.80544L8.35604 7.0318L8.12969 7.8636L7.27506 7.7556L6.74753 8.43635L5.99933 8.00798ZM9.29331 10.1808L8.49351 10.1688L7.93649 10.7428L7.20955 8.98785L7.585 8.5034L8.64765 8.63767L8.65021 8.62827L9.29331 10.1808Z",
    fill: "#28245C",
    style: {
      fill: "#28245C",
      fill: "color(display-p3 0.1569 0.1412 0.3608)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9997 1.99219C4.52011 1.99219 3.31641 3.19589 3.31641 4.67548C3.31641 6.15507 4.52011 7.3588 5.9997 7.3588C7.47929 7.3588 8.68299 6.15507 8.68299 4.67548C8.68299 3.19589 7.47927 1.99219 5.9997 1.99219ZM5.9997 6.65574C4.90777 6.65574 4.01944 5.76739 4.01944 4.67546C4.01944 3.58353 4.90777 2.69522 5.9997 2.69522C7.09163 2.69522 7.97996 3.58355 7.97996 4.67548C7.97996 5.76741 7.09161 6.65574 5.9997 6.65574Z",
    fill: "#28245C",
    style: {
      fill: "#28245C",
      fill: "color(display-p3 0.1569 0.1412 0.3608)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_5374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizeBlue);
export default __webpack_public_path__ + "static/media/prize-blue.98b8449cecb697d87db7d99450fa8339.svg";
export { ForwardRef as ReactComponent };